// components/Projects.jsx
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCalendar,
    faMapMarkerAlt,
    faRuler,
    faArrowRight
} from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { projectsData } from '../components/data/projectsData';

const Projects = () => {
    const navigate = useNavigate();

    return (
        <div className="bg-gray-50 min-h-screen">
            {/* Hero Header */}
            <div className="w-full h-[300px] mb-10 header flex justify-center items-center relative" style={{
                backgroundImage: 'linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), url(https://images.unsplash.com/photo-1541888946425-d81bb19240f5?auto=format&fit=crop&w=2070)',
                backgroundSize: 'cover',
                backgroundPosition: 'center'
            }}>
                <div className="text-center px-3 mt-10 relative z-10" data-aos="zoom-in">
                    <h1 className="text-3xl lg:text-5xl font-extrabold text-white mb-5">Our Projects Portfolio</h1>
                    <p className="text-lg text-white">Explore our successful construction projects and transformations</p>
                </div>
            </div>

            {/* Main Content */}
            <div className="px-5 lg:px-32 py-10">
                

                {/* Projects Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-aos="fade-up">
                    {projectsData.map(project => (
                        <div
                            key={project.id}
                            className="bg-white rounded-lg shadow-md overflow-hidden cursor-pointer group hover:shadow-xl transition-all duration-300"
                            onClick={() => navigate(`/projects/${project.slug}`)}
                        >
                            {/* Image with Before/After overlay */}
                            <div className="relative h-64 overflow-hidden">
                                <img
                                    src={project.afterImages[0]}
                                    alt={project.title}
                                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>

                                {/* Before/After Indicator */}
                                <div className="absolute top-4 left-4 flex space-x-2">
                                    <span className="bg-black/70 text-white px-3 py-1 rounded-full text-sm font-semibold">
                                        BEFORE
                                    </span>
                                    <span className="bg-yellow-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                                        AFTER
                                    </span>
                                </div>

                                {/* Project Type */}
                                <div className="absolute top-4 right-4">
                                    <span className="bg-yellow-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                                        {project.type}
                                    </span>
                                </div>

                                {/* Status Badge */}
                                <div className="absolute bottom-4 left-4">
                                    <span className={`px-3 py-1 rounded-full text-sm font-semibold ${project.status === 'Completed'
                                            ? 'bg-green-100 text-green-800'
                                            : 'bg-yellow-100 text-yellow-800'
                                        }`}>
                                        {project.status}
                                    </span>
                                </div>
                            </div>

                            {/* Project Info */}
                            <div className="p-6">
                                <h3 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-yellow-600 transition-colors">
                                    {project.title}
                                </h3>
                                <p className="text-gray-600 mb-4 line-clamp-2">{project.shortDescription}</p>

                                {/* Project Details */}
                                <div className="grid grid-cols-2 gap-3 mb-4">
                                    <div className="flex items-center space-x-2">
                                        <FontAwesomeIcon icon={faMapMarkerAlt} className="text-gray-400" />
                                        <span className="text-sm text-gray-600">{project.location}</span>
                                    </div>
                                    <div className="flex items-center space-x-2">
                                        <FontAwesomeIcon icon={faCalendar} className="text-gray-400" />
                                        <span className="text-sm text-gray-600">{project.duration}</span>
                                    </div>
                                    <div className="flex items-center space-x-2">
                                        <FontAwesomeIcon icon={faRuler} className="text-gray-400" />
                                        <span className="text-sm text-gray-600">{project.area}</span>
                                    </div>
                                 
                                </div>

                                {/* View Details Button */}
                                <div className="flex justify-between items-center pt-4 border-t border-gray-100">
                                    <span className="text-yellow-600 font-semibold text-sm">View Project Details</span>
                                    <FontAwesomeIcon
                                        icon={faArrowRight}
                                        className="text-yellow-600 transform group-hover:translate-x-2 transition-transform"
                                    />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

            
                {/* CTA Section */}
                <div className="mt-16 bg-gradient-to-r from-yellow-600 to-yellow-700 text-white rounded-2xl p-8 text-center" data-aos="fade-up">
                    <h2 className="text-3xl font-bold mb-4">Have a Project in Mind?</h2>
                    <p className="text-xl mb-8 max-w-2xl mx-auto">
                        Let's discuss how we can bring your construction vision to life with our expertise and quality craftsmanship.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-4 justify-center">
                        <button
                            onClick={() => navigate('/contact')}
                            className="bg-white text-yellow-700 font-bold py-3 px-8 rounded-lg hover:bg-gray-100 transition-colors"
                        >
                            Get  Consultation
                        </button>
                        <button
                            onClick={() => navigate('/services')}
                            className="bg-transparent border-2 border-white text-white font-bold py-3 px-8 rounded-lg hover:bg-white/10 transition-colors"
                        >
                            View Our Services
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Projects;